import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withToast } from '@vtex/styleguide/lib/ToastProvider'
import Alert from '@vtex/styleguide/lib/Alert'

const toastBasePropTypes = {
  duration: PropTypes.number.isRequired,
  showToast: PropTypes.func.isRequired,
}

class ToastWebHookNotification extends PureComponent {
  state = {}

  static getDerivedStateFromProps(props, state) {
    return {
      currentMessage: props.message,
      lastMessage: state && state.currentMessage,
    }
  }

  showToast() {
    if (this.props.message !== this.state.lastMessage) {
      this.props.showToast({
        message: this.props.message,
        duration: this.props.duration,
      })
    }
  }

  componentDidUpdate() {
    this.showToast()
  }

  componentDidMount() {
    this.showToast()
  }

  render() {
    return null
  }
}

ToastWebHookNotification.propTypes = {
  ...toastBasePropTypes,
  message: PropTypes.string.isRequired,
}

class ToastWebHookNotificationError extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      errorVisible: true,
    }

    this.el = document.querySelector(props.errorNodeSelector)
  }

  componentDidMount() {
    this.props.hideToast()
  }

  handleClose = () => {
    this.setState({
      errorVisible: false,
    })
  }

  render() {
    const { error } = this.props
    const { errorVisible } = this.state

    if (!error || !errorVisible) {
      return null
    }

    const content = (
      <div className="h3">
        <div className="absolute top-0 left-0 right-0">
          <Alert type="warning" onClose={this.handleClose}>
            {error}
          </Alert>
        </div>
      </div>
    )

    return ReactDOM.createPortal(content, this.el)
  }
}

ToastWebHookNotificationError.propTypes = {
  error: PropTypes.string,
  errorNodeSelector: PropTypes.string.isRequired,
  hideToast: PropTypes.func.isRequired,
}

const toastWebHookNotification = ({
  error,
  message,
  duration,
  showToast,
  hideToast,
  errorNodeSelector,
}) => {
  return error ? (
    <ToastWebHookNotificationError
      error={error}
      errorNodeSelector={errorNodeSelector}
      hideToast={hideToast}
    />
  ) : (
    <ToastWebHookNotification
      showToast={showToast}
      message={message}
      duration={duration}
    />
  )
}

toastWebHookNotification.defaultProps = {
  duration: 6000,
}

toastWebHookNotification.propTypes = {
  ...toastBasePropTypes,
  hideToast: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default withToast(toastWebHookNotification)
